import { createHttpClient } from '@arcotech-services/cms-core/http'

const instance = createHttpClient({ baseURL: process.env.PUBLIC_BFF_URL })

export default instance
